import { SelectOptions } from "../../types"

export const RATEFLOW_ENGINE_TEMPLATES: SelectOptions = [
  {
    id: "polly",
    name: "Polly"
  },
  {
    id: "mortech",
    name: "Mortech"
  },
  {
    id: "optimal_blue",
    name: "Optimal Blue"
  },
  {
    id: "loan_sifter",
    name: "Loan Sifter"
  },
  {
    id: "lender_price",
    name: "Lender Price"
  },
  {
    // ICE PPE was formerly known as Encompass Product and Pricing Service (EPPS)
    id: "epps",
    name: "ICE PPE"
  },
  {
    id: "loancraft",
    name: "LoanCraft"
  }
]

export const RATEFLOW_ENGINE_CONFIGS = [
  {
    api_mode: "polly",
    api_config: {
      audience_id: "",
      api_username: "BankingBridgeAPI",
      api_password: "7niDDeym6QGbs09kR6XR",
      client_id: "",
      client_secret: "",
      include_fees: false,
      fee_engine: "",
      custom_values: [{ name: "LO Name", value: "" }]
    }
  },
  {
    api_mode: "lender_price",
    api_config: {
      user_id: "",
      company_id: "",
      api_key: "!AEx8FgClara.com"
    }
  },
  {
    api_mode: "loan_sifter",
    api_config: {
      user_id: "",
      company_id: "",
      client_id: "7a50b13a-57d6-484b-8fbf-f3a83c1a5eec",
      client_secret: "nWy8Q~tZ_t6Zr0dQhglW5Yu4YXVseENs7_YyLcJs",
      fee_engine: ""
    }
  },
  {
    api_mode: "optimal_blue",
    api_config: {
      originator_id: "",
      biz_channel: "",
      fee_engine: "",
      group_requests: false
    }
  },
  {
    api_mode: "mortech",
    api_config: {
      customer_id: "",
      lead_source: null,
      email: ""
    }
  },
  {
    api_mode: "epps",
    // System-level config (host_url, token_path, api_path, partner OAuth
    // client_id/client_secret) is defaulted server-side and not set per customer.
    api_config: {
      instance_id: "",
      service_setup_id: "",
      group_requests: false,
      amount_steps: 100000,
      lockperiod_only: true,
      fee_engine: "lodestar",
      default_fees_in: false,
      testing: false
    }
  },
  {
    api_mode: "loancraft",
    // System-level config (host_url, token_path, api_path, environment) is
    // defaulted server-side from the testing flag and not set per customer.
    api_config: {
      api_key: "",
      user_id: "",
      password: "",
      group_requests: false,
      amount_steps: 100000,
      testing: false
    }
  }
]
